import { assign } from 'xstate';

import { calculateActiveCalories } from '../../helpers';
import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Calculate total calories based on the product, active modifications,
 * and mixed dressing details.
 */
export const calculateCalories: CustomizationMachineAction = assign((args) => {
  const { modifications, product, mixedDressingDetails } = args.context;
  const activeModifications = modifications?.active;

  if (!product || !activeModifications) {
    return {};
  }

  const calories = calculateActiveCalories({
    product,
    activeModifications,
    mixedDressingDetails,
  });

  return {
    calories,
  };
});
